import React, {Component} from "react";
import Select from "@material-ui/core/Select";
import {FormControl} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

import PropTypes from "prop-types";
import InputAdornment from "@material-ui/core/InputAdornment";
import MaterialIcon from "../MaterialIcon";
import View from "../../modules/repos/contributions/View";

/**
 * ID does not work as expected
 * */
export default class MaterialSelect extends Component {


    static defaultProps = {
        color: "secondary",
        style: {},
        marginTop:0,
        selectionItems: [],
        selectionHeader: undefined,
        maxRows: undefined,
        selectionFooter: undefined,
        value: "",
        onChange(e, item) {
            console.log(`Unhandled item select change`);
        },
        renderValue: undefined
    };

    static propTypes = {
        color: PropTypes.string,
        disableUnderline: PropTypes.bool,
        selectionItems: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.number,
                value: PropTypes.any
            })
        ),
        selectionHeader: PropTypes.any,
        selectionFooter: PropTypes.any,
        labelId: PropTypes.string,
        id: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func,
        renderValue: PropTypes.any,
        labelText: PropTypes.string,
        startAdornment: PropTypes.any,
        multiple: PropTypes.bool,
        ...View.propTypes
    };

    get selectionItems() {
        let {selectionItems, children} = this.props;

        this.selectionItemsField = selectionItems === undefined ? children : selectionItems.map(({key, value}) => {

            return (
                <MenuItem key={key} value={key}>{value}</MenuItem>
            );
        });


        return this.selectionItemsField;
    }

    get basicInput() {

        let {
            selectionItems,
            labelId,
            labelText,
            label,
            startIcon,
            children: items,
            selectionHeader,
            selectionFooter,

            ...props
        } = this.props;

        let style = View.extractStyles(this.props);

        if (startIcon !== undefined) {

            if (typeof startIcon === "string") {
                startIcon = <MaterialIcon icon={startIcon}/>;
            }

            props.startAdornment = (
                <InputAdornment position="start">
                    {startIcon}
                </InputAdornment>
            );
        }

        return (
            <Select style={style} {...props}  >
                {selectionHeader}
                {this.selectionItems}
                {selectionFooter}
            </Select>
        );
    }

    get withLabel() {
        let {
            selectionItems,
            labelId,
            labelText,
            label,
            children,
            startIcon,
            selectionHeader,
            selectionFooter,
            ...props
        } = this.props;

        if (startIcon !== undefined) {

            if (typeof startIcon === "string") {
                startIcon = <MaterialIcon icon={startIcon}/>;
            }

            props.startAdornment = (
                <InputAdornment position="start">
                    {startIcon}
                </InputAdornment>
            );
        }

        return (
            <>
                <InputLabel shrink id={labelId}>{labelText}</InputLabel>
                <Select {...props}>
                    {selectionHeader}
                    {this.selectionItems}
                    {selectionFooter}
                </Select>
            </>
        );
    }


    get input() {
        return this.props.labelId === undefined ? this.basicInput : this.withLabel;
    }


    render() {
        /*Prepares required defaultValue*/
        let {
            color,
            selectionItems = this.selectionItems,
            renderValue,
            labelText,
            disableUnderline,
            materialLabel,
            menuTitleText,
            labelId,
            startIcon,
            startAdornment,
            style,
            marginTop,
            children,
            selectionHeader,
            selectionFooter,
            ...props
        } = this.props;

        // variant={"outlined"}  not logical too big a button that isn't stylable from here
        return (
            <FormControl {...props} >
                {this.input}
            </FormControl>
        );
    }
}